// extracted by mini-css-extract-plugin
export default {"textarea":"styles_textarea__N-Hwj","error":"styles_error__hhWL-"};